import { validationConstants } from "constants/formValidation";
import useFormValidation from "hooks/useFormValidation";
import { Label } from "layout/typography/Label";
import { validateInputDatePicker } from "pages/CreateOrder/utils/helpers";
import {
  handleChangeDateWithMask,
  handleChangePhoneWithMask,
} from "pages/CreateOrder/utils/mask";
import { InputText } from "primereact/inputtext";
import { Controller, useFormContext } from "react-hook-form";
import { IDirectPayLinkPublicConfig } from "types/DirectPayLink.d";

interface IPatientInfoProps {
  linkConfig?: IDirectPayLinkPublicConfig | null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function PatientInfo({ linkConfig }: IPatientInfoProps) {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { handleOnBlurField, getFormErrorMessage } = useFormValidation();
  return (
    <div className="flex flex-column gap-3">
      <p className="font-bold text-lg black">Patient Information</p>
      <div className="formgrid grid w-100">
        <div className="field flex flex-column col-12 md:col-6">
          <Label htmlFor="firstName">First Name</Label>

          <Controller
            name="firstName"
            control={control}
            rules={{
              required: validationConstants.PATIENT_INFO_FORM.FIRST_NAME,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <>
                <InputText
                  id="firstName"
                  autoComplete="off"
                  value={value || ""}
                  placeholder="First Name"
                  aria-labelledby="firstName"
                  onBlur={() => {
                    handleOnBlurField({
                      onBlur,
                      field: "firstName",
                      trigger,
                    });
                  }}
                  onChange={onChange}
                />

                {getFormErrorMessage("firstName", errors)}
              </>
            )}
          />
        </div>
        <div className="field flex flex-column col-12 md:col-6">
          <Label htmlFor="lastName">Last Name</Label>

          <Controller
            name="lastName"
            control={control}
            rules={{
              required: validationConstants.PATIENT_INFO_FORM.LAST_NAME,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <>
                <InputText
                  id="lastName"
                  value={value || ""}
                  autoComplete="off"
                  placeholder="Last Name"
                  onBlur={() =>
                    handleOnBlurField({ onBlur, field: "lastName", trigger })
                  }
                  onChange={onChange}
                />

                {getFormErrorMessage("lastName", errors)}
              </>
            )}
          />
        </div>

        <div className="field flex flex-column col-12 md:col-6">
          <Label htmlFor="dateOfBirth">Date of Birth</Label>

          <Controller
            name="dateOfBirth"
            control={control}
            rules={{
              validate: (date) =>
                validateInputDatePicker(date, "past", undefined, true),
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <>
                <InputText
                  value={value || ""}
                  id="dateOfBirth"
                  placeholder="99/99/9999"
                  onBlur={() =>
                    handleOnBlurField({
                      onBlur,
                      field: "dateOfBirth",
                      trigger,
                    })
                  }
                  onChange={(e) => handleChangeDateWithMask(e, onChange)}
                />

                {getFormErrorMessage("dateOfBirth", errors)}
              </>
            )}
          />
        </div>
        <div className="field flex flex-column col-12 md:col-6">
          <Label htmlFor="phoneNumber">Phone Number</Label>

          <Controller
            control={control}
            name="phoneNumber"
            rules={{
              required: validationConstants.PATIENT_INFO_FORM.PHONE,
              pattern: {
                value: /^\(\d{3}\) \d{3}-\d{4}$/,
                message:
                  "Please enter a valid phone number in format (XXX) XXX-XXXX",
              },
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <>
                <InputText
                  value={value || ""}
                  id="phoneNumber"
                  autoComplete="off"
                  placeholder="Phone Number"
                  onBlur={() =>
                    handleOnBlurField({
                      onBlur,
                      field: "phoneNumber",
                      trigger,
                    })
                  }
                  onChange={(e) => {
                    handleChangePhoneWithMask(e, onChange);
                  }}
                />

                {getFormErrorMessage("phoneNumber", errors)}
              </>
            )}
          />
        </div>
      </div>
    </div>
  );
}
